import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForgotPasswordMutation } from "../../redux/api/userApi";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import MetaData from "../layout/MetaData";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const [forgotPassword, { isLoading, error, isSuccess }] =
        useForgotPasswordMutation();
    const { isAuthenticated } = useSelector((state) => state.auth);

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/");
        }
        if (error) {
            toast.error(error?.data?.message);
        }
        if (isSuccess) {
            toast.success("Email sent. Please check your inbox");
        }
    }, [error, isAuthenticated, isSuccess, navigate]);

    const submitHandler = (e) => {
        e.preventDefault();
        forgotPassword({ email });
    };

    return (
        <>
            <MetaData title={"Forgot Password"} />
            <main className="main-content">
                <div className="login-wrapper">
                    <div className="login-card shadow-lg rounded-4">
                        <form onSubmit={submitHandler}>
                            <h2 className="mb-4 text-center fw-bold text-dark">
                                Forgot Password 🔑
                            </h2>

                            {/* Email Input */}
                            <div className="mb-3">
                                <label
                                    htmlFor="email_field"
                                    className="form-label fw-semibold"
                                >
                                    Enter your email
                                </label>
                                <input
                                    type="email"
                                    id="email_field"
                                    className="form-control rounded-3 p-2"
                                    name="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your registered email"
                                />
                            </div>

                            {/* Button */}
                            <button
                                id="forgot_password_button"
                                type="submit"
                                className="btn w-100 py-2 fw-semibold login-btn"
                                disabled={isLoading}
                            >
                                {isLoading ? "Sending..." : "Send Reset Link"}
                            </button>
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
};

export default ForgotPassword;
